import { defineMessages } from '@formatjs/intl';

const messages = defineMessages({
	signupFormHeadingNoDiscount: {
		id: 'lifetime.discount.signup.title.2.noDiscount',
		defaultMessage: 'Sleep better and stress less today',
		description: 'The title for the Calm signup component',
	},
	signupFormHeading: {
		id: 'lifetime.discount.signup.title.2',
		defaultMessage: 'Get a lifetime of rest and relief {percentOff}% off!',
		description: 'The title for the Calm signup component with a perceent off discount',
	},
	loginFormHeading: {
		id: 'lifetime.discount.login.title',
		defaultMessage: 'Log into your Calm account',
		description: 'The title for the Calm login component',
	},
	accountValuePropHeaderNoDiscount: {
		id: 'lifetime.discount.account.valueproplist.header.noDiscount',
		defaultMessage: 'Continue your mindfulness journey with Calm Premium',
		description: 'Value props of calm with Calm Premium',
	},
	accountValuePropHeader: {
		id: 'lifetime.discount.account.valueproplist.header',
		defaultMessage: 'Continue your mindfulness journey with {percentOff}% off Calm Premium',
		description: 'Value props of calm with a percentage off Calm Premium',
	},
	terms: {
		id: 'lifetime.discount.payment.terms.short2',
		defaultMessage:
			'This lifetime membership gives you unlimited access to Calm’s entire library of content. You will be charged {price} for a lifetime subscription, billed once.',
		description: 'A line to inform the user of the terms of their trial',
	},
	offerTerms: {
		id: 'purchaseTerms.noTrialTermsEligibility2.lifetime',
		defaultMessage:
			'By clicking "Get Calm Premium", you agree to be automatically billed for Calm Premium at {price} for a lifetime subscription.',
		description: 'Terms for if user is not eligible for trial',
	},
});

export default messages;
